// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanCreate } from "./hook";

export type CanCreateProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanCreate({ children, fallback, scope }: CanCreateProps) {
  const canDoAction = useCanCreate(scope);
  return <>{canDoAction ? children : fallback}</>;
}
